import React, { useEffect } from 'react'
import { createPortal } from 'react-dom'

import styles from './Loading.module.scss'

const Loading = () => {
  const modal = document.getElementById('modal')

  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [])

  return (
    modal &&
    createPortal(
      <div className={styles.loading}>
        <div className={styles.loading_wrapper}>
          <div className={styles.loading_container}>
            <div className={styles.loading_spinner}></div>
          </div>
        </div>
      </div>,
      modal,
    )
  )
}

export default Loading
